export enum TableColumnKey {
  CreationTime = 'creationTime',
  LastModifiedTime = 'lastModifiedTime',
  PfhNumber = 'pfhNumber',
  Currency = 'currency',
  Balance = 'balance',
  FrozenBalance = 'frozenBalance',
  ClientId = 'clientId',
}

export interface TableRow {
  id: number;
  // [TableColumnKey.PfhNumber]: string;
  [TableColumnKey.ClientId]: string;
  [TableColumnKey.Currency]: string;
  [TableColumnKey.Balance]: string;
  [TableColumnKey.FrozenBalance]: string;
  [TableColumnKey.CreationTime]: string;
  [TableColumnKey.LastModifiedTime]: string | undefined;

  rawData: any;
}
